import { MkIcon } from "@/mk/MkIcon";
import type { MouseEvent, ReactNode } from "react";

type Variant = "primary" | "secondary" | "soft" | "ghost" | "danger" | "success"
    | "warning" | "info" | "outline" | "link";

interface Props {
    label?: string;
    icon?: string;
    iconRight?: string;
    variant?: Variant;
    size?: "xs" | "sm" | "md" | "lg";
    block?: boolean;
    pill?: boolean;
    loading?: boolean;
    disabled?: boolean;
    type?: "button" | "submit";
    className?: string;
    title?: string;
    onClick?(event: MouseEvent<HTMLButtonElement>): void;
    children?: ReactNode;
}

export function MkButton({ label, icon, iconRight, variant = "primary", size = "md",
                           block, pill, loading, disabled, type = "button", className,
                           title, onClick, children }: Props) {
    const classes = ["mk-btn", `mk-btn-${variant}`, `mk-btn-${size}`,
                     block ? "mk-btn-block" : "", pill ? "mk-btn-pill" : "",
                     loading ? "mk-btn-loading" : "", className ?? ""]
        .filter(Boolean).join(" ");
    return (
        <button type={type} className={classes} disabled={disabled} title={title} aria-label={label || title}
                onClick={(event) => {
                    if (!loading && !disabled) {
                        onClick?.(event);
                    }
                }}>
            {loading && <span className="mk-btn-spinner" />}
            {icon && !loading && <MkIcon name={icon} />}
            {(label || children) && (
                <span className="mk-btn-label">{children ?? label}</span>
            )}
            {iconRight && <MkIcon name={iconRight} />}
        </button>
    );
}
